import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

export type InputOf<TMutationFn> = TMutationFn extends (
  input: infer TInput,
) => unknown
  ? TInput
  : never;

export function useMbcAdminMutation<TInput, TResult>(
  mutationFn: (input: TInput) => Promise<TResult>,
  queryKey: readonly string[],
): UseMutationResult<TResult, Error, TInput> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });
}
